import { useSuspenseQueries } from '@tanstack/react-query';
import { queryCategories } from '@/queries/categories';
import { filterStorefrontCategoryGroups } from '@/queries/categories/categories.visibility';
import { CategoryGroupKey, LOBBY_CATEGORY_GROUP_KEYS } from '@/queries/categories/types/categoryGroupKey';
import { sortCategoriesByOrder } from '@/utils/sortCategoriesByOrder';

export const useGroupCategories = () => {
  const results = useSuspenseQueries({
    queries: LOBBY_CATEGORY_GROUP_KEYS.map(groupKey =>
      queryCategories({ filters: { groupKey } }),
    ),
  });

  const dataByKey = Object.fromEntries(
    LOBBY_CATEGORY_GROUP_KEYS.map((key, i) => [key, results[i]?.data]),
  );

  const getLobbyCategories = (groupKey: CategoryGroupKey) =>
    sortCategoriesByOrder(filterStorefrontCategoryGroups(dataByKey[groupKey]?.items));

  return {
    beforeFavoritesCategories: getLobbyCategories(CategoryGroupKey.BEFORE_FAVORITES),
    afterFavoritesCategories: getLobbyCategories(CategoryGroupKey.AFTER_FAVORITES),
    otherCategories: getLobbyCategories(CategoryGroupKey.OTHER_CATEGORIES),
    moreCategories: getLobbyCategories(CategoryGroupKey.MORE_CATEGORIES),
  };
};
